module.exports = __webpack_public_path__ + "img/Jump Casting81.398e41a8.jpg";